export default {"src":"/_next/static/image/src/assets/icons/filter-icons/terrace.c421a26066d3fd856be28dd0c3a197be.svg","height":14,"width":22};